export * from './config-form.js';
export * from './error.js';
export * from './metadata.js';
export * from './foundation.js';
export * from './passwordless.js';
export * from './social.js';
export * from './email-template.js';
export var DemoConnector;
(function (DemoConnector) {
    DemoConnector["Sms"] = "riven-auth-sms";
    DemoConnector["Social"] = "riven-auth-social-demo";
})(DemoConnector || (DemoConnector = {}));
export const demoConnectorIds = Object.freeze([
    DemoConnector.Sms,
    DemoConnector.Social,
]);
export var ServiceConnector;
(function (ServiceConnector) {
    ServiceConnector["Email"] = "riven-auth-email";
})(ServiceConnector || (ServiceConnector = {}));
export const serviceConnectorIds = Object.freeze([ServiceConnector.Email]);
